import { render } from "./KryptonDiscountPanel.vue?vue&type=template&id=0aece87a&lang=pug"
import script from "./KryptonDiscountPanel.vue?vue&type=script&lang=js"
export * from "./KryptonDiscountPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__